import {Directive, Input, TemplateRef} from "@angular/core";
import {DimensionControlsService} from "./dimension-controls.service";

@Directive({selector: "[dimensionControl]"})
export class DimensionControlDirective {

    constructor(private templateRef: TemplateRef<any>,
                private dimensionControlsService: DimensionControlsService) {
    }

    @Input() set dimensionControl(field: string) {
        this.dimensionControlsService.registerTemplate(field, this.templateRef);
    }
}
